// @greenlight-spec: 11-observability.md#control-plane-internal-health
// @greenlight-spec: 26-versioning-update-strategy.md#release-validation
// @greenlight-spec: 19-design-system.md
import * as React from 'react';
import { FlaskConical } from 'lucide-react';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { api } from '@/lib/api';

/**
 * Present only on a release-validation install: one that takes prereleases
 * and that Shift has marked as gating customer releases. Every other install
 * renders nothing — the role is the exception, so its absence is silent.
 */
export function ReleaseValidationBanner({ pollMs }: { pollMs: number }): React.ReactElement | null {
  const { data } = api.health.latestFleetReport.useQuery(['health-fleet-report'], undefined, {
    queryKey: ['health-fleet-report'],
    refetchInterval: pollMs,
  });
  const releaseValidation = data?.status === 200 ? data.body.release_validation : undefined;
  if (releaseValidation?.enabled !== true) return null;

  return (
    <Alert variant="warning" data-testid="release-validation-banner">
      <FlaskConical className="size-4" aria-hidden />
      <AlertTitle>This install validates releases for Shift</AlertTitle>
      <AlertDescription>
        It takes prereleases and Shift has marked it as gating customer releases, so it runs the
        provider contract suites and the end-to-end suite against every prerelease it applies and
        reports the verdicts. Turning either off — the updater&rsquo;s prerelease setting, or the
        mark on the fleet monitor — stops that on the next apply.
      </AlertDescription>
    </Alert>
  );
}
